// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-loading-wrapper{position:relative}.table-loading-backdrop{background:hsla(0,0%,100%,.75);display:flex;align-items:center;justify-content:center;position:absolute;top:0}.table-loading-indicator{background:50%/50px no-repeat url(/wp-content/themes/snappy-theme/assets/images/loading2.gif);width:50px;height:50px}.modal .modal-body form>.form-group{margin:auto}", ""]);
// Exports
module.exports = exports;
